export default {
  DOWN_EXCEL_TEMPLATE_API: '/maindata/dict/ossFileDownloadUrl', // 下载excel模板
};
